import { P, Li, A, Part, LegalPage } from "@/components/legal";

/* Условия использования сайта. Только то, что уже заявлено на сайте и в политике
   (бесплатный разбор, форма, Telegram, физлицо без статуса ИП). Нового обещания
   и юридических формул сверх этого нет. Перед публикацией показать юристу:
   текст составлен не юристом. */
const REVISION_DATE = "27 октября 2026 года";

export default function Terms() {
  return (
    <LegalPage title="Условия использования сайта" meta={`Редакция от ${REVISION_DATE} · версия 1.0`}>
      <Part n="1" title="О сайте" first>
        <P>
          Сайт Gride.pro принадлежит Григорьеву Данилу Сергеевичу, физическому лицу без статуса
          индивидуального предпринимателя или самозанятого. Сайт рассказывает о том, как я
          разбираю процессы малого бизнеса, и принимает заявки на письменный разбор.
        </P>
      </Part>

      <Part n="2" title="Что такое письменный разбор">
        <P>
          Письменный разбор бесплатный. Отправка формы не создаёт договор и не порождает
          финансовых обязательств ни для одной из сторон. В разборе я описываю процесс, оцениваю
          потери и называю вилку цены. Это моё мнение по тем данным, которые ты указал, а не
          гарантия результата и не публичная оферта.
        </P>
        <P>
          Если задача не подходит под мою работу, я напишу об этом и объясню почему.
        </P>
      </Part>

      <Part n="3" title="Работа по проекту">
        <P>
          Платная работа начинается только после отдельной договорённости: состав работ, срок,
          цена и способ оплаты согласовываются письменно до старта. Подсказки в калькуляторе на
          сайте считаются из чисел, которые вводишь ты сам, и служат прикидкой, а не расчётом
          стоимости услуги.
        </P>
      </Part>

      <Part n="4" title="Твои данные">
        <P>
          Данные из формы обрабатываются по{" "}
          <A href="/privacy" external={false}>политике обработки персональных данных</A>. Не
          указывай в форме то, что составляет коммерческую тайну или персональные данные третьих
          лиц: для разбора достаточно описания процесса своими словами.
        </P>
      </Part>

      <Part n="5" title="Материалы сайта">
        <P>
          Тексты, схемы и оформление сайта принадлежат владельцу сайта. Схема процесса в первом
          экране это иллюстрация метода, а не описание реального проекта. Сайт не содержит
          кейсов, отзывов и результатов клиентов.
        </P>
      </Part>

      <Part n="6" title="Связь">
        <ul className="list-disc list-outside space-y-2 pl-6">
          <Li>
            Telegram: <A href="https://t.me/d_evoluer">@d_evoluer</A>
          </Li>
          <Li>
            Почта: <A href="mailto:gridepro@yandex.ru" external={false}>gridepro@yandex.ru</A>
          </Li>
        </ul>
        <P>
          Эти условия могут меняться. Актуальная редакция всегда лежит на этой странице, дата
          указана вверху.
        </P>
      </Part>
    </LegalPage>
  );
}
